// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__4cK0_","item":"PaymentsMobile_item__3YCrB","label":"PaymentsMobile_label__1Rifz","amount":"PaymentsMobile_amount__2ir-y"};